exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option-container img[data-v-6653e764]{width:80px;height:80px;border:3px solid #b6b6b6;border-radius:16px}.checkbox-container>.checkmark[data-v-6653e764]{border-radius:50%;position:absolute;top:63px;background-color:#fff;border:3px solid #b6b6b6;height:28px;width:28px;left:0;right:0;margin:auto}.checkbox-container[data-v-6653e764]{padding-left:0;text-align:center;position:relative}.option-label[data-v-6653e764]{font-weight:700;margin-top:.5em}.list-options-container[data-v-6653e764]{display:flex;flex-wrap:wrap}.option-container[data-v-6653e764]{flex-basis:80px;flex-grow:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6653e764","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/form-elements/CheckboxIconGroup.vue
// module id = 869
// module chunks = 38